import React from 'react';
import classNames from 'classnames';
import Dropdown from "@scentregroup/ui/components/form/dropdown";
import map from 'lodash/map';
import { rangesForDate } from '../../helpers/time-ranges';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import { categories, actions, labels } from '../../helpers/analytics-utils/constants';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const ALL_DATES = {
  value: 'any',
  label: 'Any date'
};
const DateRangeFilter = _ref => {
  let {
    selectedDateRange,
    onChange,
    baseDate,
    className,
    id,
    dataTestId
  } = _ref;
  const ranges = rangesForDate(baseDate, selectedDateRange);
  const options = map(ranges, item => ({
    value: item.slug(),
    label: item.name
  }));
  const onDateRangeChange = e => {
    trackClickEvent(categories.WHATS_HAPPENING_FILTERS, actions.DATE_RANGE_SELECT, e.currentTarget.value === 'any' ? 'any-date' : e.currentTarget.value);
    if (e.currentTarget.value === ALL_DATES.value) {
      onChange('');
    } else {
      onChange(e.currentTarget.value);
    }
  };
  const onDateDropdown = () => {
    trackClickEvent(categories.WHATS_HAPPENING_FILTERS, actions.DATE_RANGE_EXPAND, labels.EXPAND);
  };
  options.unshift(ALL_DATES);
  return /*#__PURE__*/_jsx(Dropdown, {
    classNames: {
      wrapper: classNames(className, style.wrapper),
      field: classNames(style.field, style.fieldOverride)
    },
    size: "SMALL",
    options: options,
    value: selectedDateRange,
    id: id,
    dataTestId: dataTestId,
    onChange: onDateRangeChange,
    onClick: onDateDropdown,
    "data-id": "date-range-filter_index_DateRangeFilter_Dropdown"
  });
};
DateRangeFilter.defaultProps = {
  selectedDateRange: ALL_DATES.value
};
export default DateRangeFilter;